import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { DropdownToggle, Dropdown, Modal, ModalHeader } from 'reactstrap';
import Menu from './_dropdownMenu';
import Settings from './__settings';

const mapStateToProps = ({ user: { user_avatar, first_name, email, role_codes, options } }) => ({
  user_avatar,
  first_name,
  email,
  role_codes,
  options
});

const HeaderDropdown = ({ user_avatar, first_name, email, role_codes, options }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <Dropdown nav isOpen={isOpen} toggle={() => setIsOpen(!isOpen)}>
      <DropdownToggle nav className="account_name">
        <span className="img-avatar-icon">
          <i
            className={user_avatar ? 'avatar-img' : 'fa fa-user-circle'}
            style={{ backgroundImage: `url(${user_avatar || ''})` }}
          />
        </span>
        <span style={{ display: 'inline-block' }}>
          <span style={{ display: 'block', lineHeight: 1.1 }}>{first_name}</span>
          <span style={{ fontSize: 10, lineHeight: 1.1, padding: '4px 0 6px' }}>{email}</span>
          {role_codes && (
            <span style={{ display: 'block', fontSize: 10, lineHeight: 1.1 }}>{role_codes.join(', ')}</span>
          )}
        </span>
      </DropdownToggle>
      <Link
        to="/profile"
        target={options.all_in_one_tab ? "_self" : "_blank"}
        style={{ marginLeft: 5, fontSize: 32, verticalAlign: 'text-bottom' }}
      >
        <i className="fa fa-edit" />
      </Link>
      {isOpen && <Menu closeParent={() => setIsOpen(false)} openSettings={() => setIsModalOpen(true)} />}
      {isModalOpen && (
        <Modal size="md" isOpen toggle={() => setIsModalOpen(false)}>
          <ModalHeader><FormattedMessage id="header_profile_settings" /></ModalHeader>
          <Settings close={() => setIsModalOpen(false)} />
        </Modal>
      )}
    </Dropdown>
  );
};

HeaderDropdown.propTypes = {
  user: PropTypes.objectOf(PropTypes.any),
};

export default connect(mapStateToProps)(HeaderDropdown);



// WEBPACK FOOTER //
// ./src/components/_Header/_dropdown.js